// Libraries
import { GRID_CHECKBOX_SELECTION_COL_DEF, GridColDef, useGridApiRef } from "@mui/x-data-grid-premium";
import { Button, Typography } from "@mui/material";
import clsx from "clsx";

// Types
import { IDesiredVehicle } from "@/DataPages/context/crm/interfaces";

// Components
import DataSmartTable from "@/Layouts/components/Tables/DataSmartTable";

// Constants
import { CUSTOM_PROPS, SLOTS } from "@/DataPages/components/Inventory/Tables/commonProps";

// Icons
import DeleteIcon from "@/assets/icons/actions/deleteX.svg";

type TSelectedVehicleTableProps = {
	data: IDesiredVehicle[];
	columns: GridColDef[];
	disabled: boolean;
	onRemove: (vin: string) => void;
};

export default function SelectedVehicleTable(props: Readonly<TSelectedVehicleTableProps>) {
	const { data, columns, disabled, onRemove } = props;

	const apiRef = useGridApiRef();

	if (!data?.length) {
		return null;
	}

	const REMOVABLE_COLUMN: GridColDef = {
		field: GRID_CHECKBOX_SELECTION_COL_DEF.field,
		width: 40,
		minWidth: 40,
		maxWidth: 40,
		filterable: false,
		sortable: false,
		resizable: false,
		renderHeader: () => <></>,
		renderCell: ({ row }) => (
			<Button className="!block !min-w-3 !h-auto !m-auto !p-1" onClick={() => !disabled && onRemove(row._id)} disabled={disabled}>
				<img width={13} src={DeleteIcon} className={clsx({ "cursor-pointer": true, "opacity-50": disabled })} />
			</Button>
		),
	};

	return (
		<DataSmartTable
			apiRef={apiRef}
			columns={[REMOVABLE_COLUMN, ...columns]}
			rows={data}
			maxRows={6}
			enableCustomScrollbars
			disableColumnMenu
			disableColumnResize
			hideFooter
			checkboxSelection
			slots={SLOTS}
			slotProps={{
				toolbar: {
					customComponent: (
						<Typography className="!text-default !font-montserrat !text-[12px] !font-medium">
							Selected Vehicles ({data?.length})
						</Typography>
					),
				},
				noRowsOverlay: {
					title: "No inventory results found",
					className: "font-montserrat font-medium !text-[12px]",
				},
			}}
			customProps={{
				...CUSTOM_PROPS,
				tableClassName: {
					...CUSTOM_PROPS.tableClassName,
					"-mt-[12px]": true,
				},
			}}
			rowHeight={25}
			autoHeight={false}
			columnVisibilityModel={{ _id: false }}
			disableMultipleRowSelection
			disableRowSelectionOnClick
			disableColumnSelector
		/>
	);
}
